/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Escalation tier: channel, recipients, and content
 * @export
 * @interface EscalationTierRequest
 */
export interface EscalationTierRequest {
    /**
     * Channel: EMAIL or SMS
     * @type {string}
     * @memberof EscalationTierRequest
     */
    channel?: string;
    /**
     * Recipient email addresses or E.164 phone numbers
     * @type {Array<string>}
     * @memberof EscalationTierRequest
     */
    recipients: Array<string>;
    /**
     * Email subject (for EMAIL channel)
     * @type {string}
     * @memberof EscalationTierRequest
     */
    subject?: string;
    /**
     * HTML body (for EMAIL channel)
     * @type {string}
     * @memberof EscalationTierRequest
     */
    bodyHtml?: string;
    /**
     * Plain text body (for EMAIL or SMS)
     * @type {string}
     * @memberof EscalationTierRequest
     */
    bodyPlain?: string;
}

/**
 * Check if a given object implements the EscalationTierRequest interface.
 */
export function instanceOfEscalationTierRequest(value: object): value is EscalationTierRequest {
    if (!('recipients' in value) || value['recipients'] === undefined) return false;
    return true;
}

export function EscalationTierRequestFromJSON(json: any): EscalationTierRequest {
    return EscalationTierRequestFromJSONTyped(json, false);
}

export function EscalationTierRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EscalationTierRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'channel': json['channel'] == null ? undefined : json['channel'],
        'recipients': json['recipients'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'bodyHtml': json['bodyHtml'] == null ? undefined : json['bodyHtml'],
        'bodyPlain': json['bodyPlain'] == null ? undefined : json['bodyPlain'],
    };
}

export function EscalationTierRequestToJSON(json: any): EscalationTierRequest {
    return EscalationTierRequestToJSONTyped(json, false);
}

export function EscalationTierRequestToJSONTyped(value?: EscalationTierRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'channel': value['channel'],
        'recipients': value['recipients'],
        'subject': value['subject'],
        'bodyHtml': value['bodyHtml'],
        'bodyPlain': value['bodyPlain'],
    };
}

